import { Box, Collapse } from "@mui/material";
import { ReactComponent as SVGHeart } from "assets/images/heart.svg";
import { ReactComponent as SVGChevron } from "assets/images/icons/size-24/chevron.svg";
import IMGOcta2 from "assets/images/octa2-shrink.png";
import ContentAdmin from "components/contentAdmin";
import CustomButton from "components/customButton";
import IMGMonitors from "../../assets/images/monitors.png";
import IMGSectionBackground1 from "../../assets/images/section-background1.jpg";

type SectionTwoProps = {
	isLoading: boolean;
	isMoneyBackExpanded: boolean;
	setIsMoneyBackExpanded: React.Dispatch<React.SetStateAction<boolean>>;
	buyMissions(): void;
};

function SectionTwo({
	isLoading,
	isMoneyBackExpanded,
	setIsMoneyBackExpanded,
	buyMissions
}: SectionTwoProps)
{
	return (
		<Box
			component="section"
			sx={{
				background: `url(${ IMGSectionBackground1 }) center center/cover`
			}}
		>
			<Box className="wrapper" sx={{ paddingBottom: "76px" }}>
				<h2>
					<ContentAdmin
						keyText="mission-one-firstComplete"
						keyContent="section2-title"
						defaultValue="Create the life you love starting today"
						position="left"
					/>
				</h2>
				<Box
					sx={{
						marginTop: { xl: "36px", lg: "24px" },
						paddingRight: { xl: "155px", lg: "52px" },
						display: "grid",
						gridTemplateColumns: { xl: "1fr 624px", lg: "1fr 442px", xs: "1fr" },
						gap: { xl: "92px", lg: "72px", xs: "20px" }
					}}
				>
					<Box
						component="img"
						src={IMGMonitors}
						alt=""
						sx={{
							justifySelf: "center",
							marginTop: "24px",
							height: { xl: "496px", lg: "356px" },
							width: { xs: "100%", lg: "auto" }
						}}
					/>

					<Box
						sx={{
							display: "flex",
							flexDirection: "column",
							gap: { xl: "24px", lg: "16px", xs: "8px" }
						}}
					>
						{/* Блок "Buy Full Quest Now" */}
						<Box
							sx={{
								position: "relative",
								padding: {
									xl: "56px 36px 36px 36px",
									lg: "40px 32px 26px 32px",
									xs: "24px 36px 20px 36px"
								},
								backgroundColor: "#FFFFFF",
								borderRadius: "24px",
								display: "flex",
								flexDirection: "column",
								alignItems: "center",
								gap: { xl: "32px", lg: "24px", xs: "16px" },
								color: "primary.main",
								textAlign: "center",

								"& .heart": {
									"--size": { xl: "72px", lg: "52px", xs: "56px" },
									position: "absolute",
									top: "0",
									transform: "translateY(-50%)",
									width: "var(--size)",
									height: "var(--size)",
									backgroundColor: "#FFFFFF",
									borderRadius: "50%",
									display: "flex",
									justifyContent: "center",
									alignItems: "center",
									"& svg": {
										width: { xl: "45px", lg: "32px", xs: "36px" }
									}
								},
								"& h4": {
									margin: "unset",
									font: {
										xl: "700 40px Lora-Bold",
										lg: "700 28px Lora-Bold",
										xs: "700 24px Lora-Bold"
									}
								},
								"& p": {
									margin: "unset",
									padding: "0 10px",
									font: {
										xl: "400 22px 'Open Sans'",
										lg: "400 16px 'Open Sans'",
										xs: "400 16px/150% 'Open Sans'"
									},
									textAlign: { lg: "center", xs: "left" }
								},
								"& .price": {
									font: {
										xl: "700 64px Lora-Bold",
										lg: "700 45px Lora-Bold",
										xs: "700 40px Lora-Bold"
									}
								}
							}}
						>
							<div className="heart">
								<SVGHeart />
							</div>
							<h4>Buy Full Quest Now</h4>
							<p>
								Unlock the full quest with one-time investment. Don't settle for
								mediocrity when you can experience a life that exceeds your
								wildest dreams.
							</p>
							{/* <div className="price">€399</div> */}
							<CustomButton.Contained
								loading={isLoading}
								onClick={buyMissions}
								size="medium"
								sx={{
									width: { sm: "auto", xs: "100%" }
								}}
							>
								View Packages
							</CustomButton.Contained>
						</Box>

						{/* Money back guarantee */}
						<Box
							sx={{
								overflow: "hidden",
								position: "relative",
								backgroundColor: "#FFFFFF",
								borderRadius: "24px",
								color: "primary.main",
								"& img": {
									position: "absolute",
									top: { xl: "12px", lg: "8px", xs: "4px" },
									left: "6px",
									height: { xl: "200px", lg: "137px", xs: "99px" },
									transform: "rotate(3.06deg)",
									pointerEvents: "none"
								},
								"& button": {
									width: "100%",
									height: { xl: "96px", lg: "68px", xs: "52px" },
									padding: {
										xl: "0 40px 0 80px",
										lg: "0 28px 0 56px",
										xs: "0 16px 0 32px"
									},
									backgroundColor: "unset",
									border: "unset",
									display: "flex",
									justifyContent: "center",
									alignItems: "center",
									gap: { xl: "20px", lg: "12px" },
									font: {
										xl: "700 24px 'Open Sans'",
										lg: "700 17px 'Open Sans'",
										xs: "700 14px 'Open Sans'"
									},
									color: "inherit",
									cursor: "pointer",
									"& span": {
										margin: { xs: "0 auto", lg: "unset" }
									},
									"& svg": {
										"--size": { xl: "24px", lg: "17px", xs: "14px" },
										width: "var(--size)",
										height: "var(--size)",
										transition: "linear 200ms transform",
										transform: {
											xl: `translateY(4.5px) rotate(${ isMoneyBackExpanded ? "-180deg" : "0deg" })`,
											lg: `translateY(2.5px) rotate(${ isMoneyBackExpanded ? "-180deg" : "0deg" })`,
											xs: `rotate(${ isMoneyBackExpanded ? "-180deg" : "0deg" })`
										}
									}
								},
								"& .content": {
									margin: "unset",
									padding: {
										xl: "0 38px 46px 138px",
										lg: "0 24px 32px 96px",
										xs: "0 24px 24px 64px"
									},
									font: {
										xl: "400 22px 'Open Sans'",
										xs: "400 16px 'Open Sans'"
									}
								}
							}}
						>
							<img src={IMGOcta2} alt="" />
							<button
								type="button"
								onClick={() => setIsMoneyBackExpanded((prev) => !prev)}
							>
								<span>
									<ContentAdmin
										keyText="mission-one-firstComplete"
										keyContent="section2-moneyBack-title"
										defaultValue="Money back guarantee"
										position="left"
									/>
								</span>
								<SVGChevron />
							</button>
							<Collapse in={isMoneyBackExpanded}>
								<div className="content">
									<ContentAdmin
										keyText="mission-one-firstComplete"
										keyContent="section2-moneyBack-desc"
										defaultValue="Positive change–guaranteed. We’ve helped over a thousand people around the world, just like you, find direction in life. We offer a money-back guarantee (no questions asked) because we're confident in the effectiveness of the quest."
										position="left"
									/>
								</div>
							</Collapse>
						</Box>
					</Box>
				</Box>
			</Box>
		</Box>
	);
}

export default SectionTwo;
